import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { client } from "../../../../App";
import { UserRoleEnum } from "../../../../helpers/enums";
import { isObject } from "../../../../helpers/helpers";
import { GET_REPORT_CONDOMINIUM_ADMIN_REGISTRY_AS_XLS } from "../../../../helpers/queries";
import { hideLoading, showLoading } from "../../../../reducers/app";
import { setCurrentContract } from "../../../../reducers/contracts";
import DataTable from "../../../common/DataTable/DataTable";
import AddToAccount from "../../../forms/ContractAddForm/AddToAccount";
import "./ContractListWrapper.scss";

const ContactListCtas = ({
  t,
  selectedData,
}: {
  t: any;
  selectedData: any;
}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const lsContract = useSelector((state: any) => state.contracts.list);
  const contractId = selectedData[0].contractId;
  if (lsContract.length > 0) {
    let ID = lsContract.find((obj: any) => obj.id === contractId);
    dispatch(setCurrentContract(ID));
  }
  return (
    <div className="contract-list-ctas">
      <div className="inner-container">
        <button
          type="button"
          className="see-consumption"
          onClick={() => history.push({ pathname: "/usages" })}
        >
          <span className="title-cta">{t("contract.seeConsumption")}</span>
          <i className="gc-icon-functional-arrow-right" aria-hidden="true">
            <span className="path1"></span>
            <span className="path2"></span>
          </i>
        </button>
      </div>
    </div>
  );
};

const ContactListCtasOnlineBill = ({
  t,
  selectedData,
  modalInfo,
}: {
  t: any;
  selectedData: any;
  modalInfo: any;
}) => {
  const status = selectedData[0].bolletta_online.props.property.status;
  const id = selectedData[0].bolletta_online.props.property.id;
  const email = selectedData[0].bolletta_online.props.property.email;

  return (
    <div className="contract-list-ctas">
      <div className="inner-container">
        {status === "active" ? (
          <button
            type="button"
            className="see-consumption"
            onClick={() => {
              modalInfo({ active: true, type: "DISABLE", id, email });
            }}
          >
            <span className="title-cta">{t("contract.disable")}</span>
            <i
              className="gc-icon-service-bolletta-online-2-col"
              aria-hidden="true"
            >
              <span className="path1" />
              <span className="path2" />
            </i>
          </button>
        ) : (
          <button
            type="button"
            onClick={() => {
              modalInfo({ active: true, type: "ENABLE", id, email });
              (window as any).dataLayer.push({
                event: "attivazioneBollettaStep2",
              });
            }}
          >
            <span className="title-cta">{t("common.active")}</span>
            <i
              className="gc-icon-service-bolletta-online-2-col"
              aria-hidden="true"
            >
              <span className="path1" />
              <span className="path2" />
            </i>
          </button>
        )}
      </div>
    </div>
  );
};

const ContarctListWrapper = ({
  columns,
  data,
  renderRowSubComponent,
  orderColumns,
  clickedRowIndex,
  setClickedRow,
  isDisablePage,
  disableContracts,
  t,
  tableName,
  genericError,
  hideData,
  onlineBill,
  setInfoModal,
  role,
}: {
  columns: any;
  data: any;
  renderRowSubComponent: any;
  orderColumns: any;
  clickedRowIndex: any;
  setClickedRow: any;
  isDisablePage: any;
  disableContracts: any;
  t: any;
  tableName: any;
  genericError: any;
  hideData: any;
  onlineBill: any;
  setInfoModal: any;
  role: any;
}) => {
  const dispatch = useDispatch();
  const [selectedRowsData, setSelectedRowsData] = useState([]);
  const history = useHistory();

  const handleRowSelects = (rowsIds: any, rowsData: any) => {
    const previousRow = JSON.stringify(selectedRowsData);
    const addedRow = JSON.stringify(rowsData);
    if (previousRow !== addedRow) {
      setSelectedRowsData(rowsData);
    }
  };

  const handleGenericError = () => {
    const errorAsRecord = genericError as Record<string, any>;
    let error = isObject(genericError)
      ? errorAsRecord[Object.keys(errorAsRecord)[0]]
      : genericError;
    console.log("CONTRACT LIST WRAPER", error);

    let formatedError = error.includes("_")
      ? t(`associate-contact.${error}`)
      : t(`${error}`);

    return formatedError !== "null" ? (
      <div className={"container"}>
        <div className={"row"}>
          <div className="col-sm-12 mt-5">
            <div className={"generic-error d-flex justify-content-start"}>
              <i
                className="gc-icon-functional-attention-1-col"
                aria-hidden="true"
              ></i>
              <p>{formatedError}</p>
            </div>
          </div>
        </div>
      </div>
    ) : (
      ""
    );
  };

  const renderCta = () => {
    return isDisablePage ? (
      <AddToAccount
        isDisabledPage={isDisablePage}
        selectedRowsIds={selectedRowsData}
        onSubmit={() => disableContracts(selectedRowsData)}
      />
    ) : (
      <ContactListCtas t={t} selectedData={selectedRowsData} />
    );
  };

  const renderCtaOnlineBill = () => {
    return (
      <ContactListCtasOnlineBill
        t={t}
        selectedData={selectedRowsData}
        modalInfo={setInfoModal}
      />
    );
  };

  const handleReportCondominiumAdminRegistryExport = async () => {
    dispatch(showLoading());
    client()
      .query({
        query: GET_REPORT_CONDOMINIUM_ADMIN_REGISTRY_AS_XLS,
      })
      .then((data: any) => {
        console.log(
          data.data.getReportCondominiumAdminRegistryAsXls,
          "data excel"
        );
        dispatch(hideLoading());
        window.open(
          data.data.getReportCondominiumAdminRegistryAsXls.path,
          "_blank"
        );
      })
      .catch((err: any) => {
        dispatch(hideLoading());
        console.log(err, "err excel");
      });
  };

  return (
    <>
      <div className="container contracts-container">
        <div
          className={
            role === UserRoleEnum.CONDOMINIUM_ADMIN
              ? "container-text-table with-xls-export"
              : "container-text-table"
          }
        >
          <h2 className="table-name font-bold">{tableName}</h2>
          <div>
            {hideData ? null : (
              <Link
                type="button"
                className="container-data paragraph-main-fs8"
                to="/user-profile"
              >
                {t("contract.visualization.data")}
                <i
                  className="gc-icon-functional-agreement-2-col"
                  aria-hidden="true"
                >
                  <span className="path1"></span>
                  <span className="path2"></span>
                </i>
              </Link>
            )}
            {role === UserRoleEnum.CONDOMINIUM_ADMIN ? (
              <button
                type="button"
                className="container-data paragraph-main-fs8"
                onClick={() => handleReportCondominiumAdminRegistryExport()}
              >
                {t("download.aggregate.contracts.xls")}
                <svg
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M15.53 15.0329C15.6662 15.0329 15.7786 15.0819 15.8672 15.18C15.9557 15.2781 16 15.3903 16 15.5164C16 15.6566 15.9557 15.7722 15.8672 15.8633C15.7786 15.9544 15.6662 16 15.53 16H0.469987C0.333759 16 0.221371 15.9544 0.132822 15.8633C0.0442742 15.7722 0 15.6566 0 15.5164C0 15.3903 0.0442742 15.2781 0.132822 15.18C0.221371 15.0819 0.333759 15.0329 0.469987 15.0329H15.53ZM8.01022 0C8.13282 0 8.24181 0.0490583 8.33716 0.147175C8.43252 0.245291 8.4802 0.357424 8.4802 0.483574V11.9212L12.7305 7.54796C12.8123 7.44985 12.9178 7.40079 13.0473 7.40079C13.1767 7.40079 13.2891 7.44985 13.3844 7.54796C13.4798 7.63206 13.5275 7.74069 13.5275 7.87385C13.5275 8.00701 13.4798 8.12265 13.3844 8.22076L8.33716 13.435C8.2963 13.463 8.25883 13.4875 8.22478 13.5085C8.19072 13.5296 8.15326 13.5471 8.11239 13.5611H7.96935H7.88761C7.84674 13.5471 7.80928 13.5296 7.77522 13.5085C7.74117 13.4875 7.7037 13.463 7.66284 13.435L2.61558 8.22076C2.52022 8.12265 2.47254 8.00701 2.47254 7.87385C2.47254 7.74069 2.52022 7.63206 2.61558 7.54796C2.71094 7.44985 2.82333 7.40079 2.95275 7.40079C3.08216 7.40079 3.19455 7.44985 3.28991 7.54796L7.5198 11.9212V0.483574C7.5198 0.357424 7.56748 0.245291 7.66284 0.147175C7.75819 0.0490583 7.87399 0 8.01022 0Z"
                    fill="black"
                  ></path>
                </svg>
              </button>
            ) : null}
          </div>
        </div>
        {data.length > 0 && (
          <DataTable
            setClickedRow={setClickedRow}
            singleCheckbox={clickedRowIndex}
            selectedRowsIds={handleRowSelects}
            renderRowSubComponent={renderRowSubComponent}
            dtTable={[]}
            columns={columns}
            columnOrder={orderColumns}
            data={data}
          />
        )}
        {genericError && isDisablePage && handleGenericError()}
        {!onlineBill && selectedRowsData && selectedRowsData.length
          ? renderCta()
          : onlineBill && selectedRowsData && selectedRowsData.length
          ? renderCtaOnlineBill()
          : null}
      </div>
    </>
  );
};

ContarctListWrapper.propTypes = {};

export default ContarctListWrapper;
